<template>
  <div>
    <el-card class="prodinfo--card">
      <z-search :configs="configs" v-model="searchData" ref="search" @do-query="query"></z-search>
    </el-card>
    <el-card style="margin-top: 10px">
      <div class="mb-16" style="display: flex; justify-content: space-between">
        <el-button
          type="primary"
          @click="$router.push({ name: 'out-stock-add' })"
          icon="el-icon-plus"
          v-auth="'storage::out-stock::out-stock-add'"
        >
          {{ $t('storage::out-stock::add_stock') }}
        </el-button>
        <!-- <el-button @click="exportOrder">
          导入
        </el-button> -->
      </div>
      <z-table
        :columns="tableColumns"
        :data="tableData"
        :max-height="500"
        v-loading="loading"
        :pagination.sync="pagination"
        class="prodinfo--table"
        @page-change="handlePageChange"
      >
        <template #stockNo="{ row }">
          <el-button type="text" @click="$router.push(`/storage/out-stock/detail/${row.id}`)">
            {{ row.stockNo }}
          </el-button>
        </template>
        <template #auditorName="{ row }">
          <div>{{ $t('storage::out-stock::table_auditor') }}: {{ $dataCheck(row.auditorName, '--') }}</div>
          <div>{{ $t('storage::out-stock::table_audit_time') }}: {{ $dataCheck(row.auditTime, '--') }}</div>
        </template>
        <template #status="{ row }">
          <span>
            <i class="circle" :style="{ background: orderStatus[row.status].color }"></i>
            {{ orderStatus[row.status].label }}
          </span>
        </template>
        <template #stockTypeName="{ row }">
          <span>{{ $t(`system::outStock::type::${row.stockTypeName}`) }}</span>
        </template>
        <template #opt="{ row }">
          <template v-if="row.status == 1">
            <el-button type="text" @click="toAudit(row)" v-auth="'storage::out-stock::out-stock-add'">
              {{ $t('storage::out-stock::table_btn_audit') }}
            </el-button>
            <el-button
              type="text"
              @click="$router.push(`/storage/out-stock/update/${row.id}`)"
              v-auth="'storage::out-stock::out-stock-update'"
            >
              {{ $t('storage::out-stock::table_edit') }}
            </el-button>
            <el-button type="text" @click="toClose(row)" style="color: #d9001b" v-auth="'storage::out-stock::close'">
              {{ $t('storage::out-stock::table_close') }}
            </el-button>
          </template>
          <el-button
            type="text"
            v-else
            @click="$router.push(`/storage/out-stock/detail/${row.id}`)"
            v-auth="'storage::out-stock::out-stock-detail'"
          >
            {{ $t('storage::out-stock::table_detail') }}
          </el-button>
        </template>
      </z-table>
    </el-card>
    <el-dialog :visible.sync="isShowClose" width="500px">
      <div slot="title">
        {{ $t('storage::out-stock::close_out_bill') }}
      </div>
      <el-form label-width="70px">
        <el-form-item :label="$t('storage::out-stock::out_bill_num')">
          {{ selectStock.stockNo }}
        </el-form-item>
        <el-form-item :label="$t('storage::out-stock::close_reason')">
          <el-input
            v-model="closeReason"
            rows="4"
            type="textarea"
            maxlength="64"
            show-word-limit
            style="width: 300px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowClose = false">
          {{ $t('storage::out-stock::add_cancel') }}
        </el-button>
        <el-button type="primary" @click="closeStockOrder">
          {{ $t('storage::out-stock::add_add') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { outSearchConfig, OUT_STORAGE_COLUMNS, ORDER_STATUS } from './config'
import { getSupplierList } from '@/server/product'
import { getStockTable, checkStockOrder, closeStockOrder, getUserList } from '@/server/stock'
import { getDicByCode } from '@/server/common'
export default {
  data() {
    return {
      configs: outSearchConfig(),
      searchData: {},
      pagination: {
        pageNum: 1, // 页码
        pageSize: 20, // 每页大小
        total: 0
      },
      orderStatus: ORDER_STATUS,
      tableColumns: OUT_STORAGE_COLUMNS,
      tableData: [],
      isShowClose: false, // 关闭库存单弹窗
      selectStock: {},
      closeReason: '',
      loading: false
    }
  },
  mounted() {
    this.getOutStorageConfig()
    this.handlePageChange()
  },
  methods: {
    async getOutStorageConfig() {
      let supplierList = []
      let shopUserList = []
      let typeList = []
      const supplier = await getSupplierList({
        page_num: 1,
        status: 1,
        page_size: 10000
      })
      const shopUser = await getUserList()
      supplierList = supplier.data.data.items.map(item => {
        return { label: item.name, value: item.id }
      })
      const { data } = await getDicByCode(7)
      if (data.code === this.$code) {
        typeList = data.data.map(item => {
          return { label: this.$t(`system::outStock::type::${item.name}`), value: item.id }
        })
      }
      shopUserList = shopUser.data.data.map(item => {
        return { label: item.userName, value: item.userId }
      })
      this.configs = outSearchConfig(supplierList, shopUserList, typeList)
    },
    query(data) {
      this.pagination.pageNum = 1
      this.getTableData(data)
    },
    async getTableData(d) {
      const params = {
        ...this.pagination,
        type: 2,
        ...d
      }
      delete params.total
      this.loading = true
      const { data } = await getStockTable(params)
      if (data.code === this.$code) {
        this.tableData = data.data.items
        this.pagination.total = data.data.totalCount
      }
      this.loading = false
    },
    handlePageChange() {
      this.$nextTick(() => {
        const params = this.$refs.search.getSearchParams()
        this.getTableData(params)
      })
    },
    toAudit(row) {
      this.$confirm(`<div style='width: 250px;'>${row.stockNo}</div><div>${$t('storage::out-stock::detail_audit_decrease')}</div>`, $t('storage::out-stock::detail_audit_decrease_tip'), {
        confirmButtonText: $t('storage::out-stock::add_add'),
        cancelButtonText: $t('storage::out-stock::add_cancel'),
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.checkStockOrder(row.id)
      })
    },
    // 审核单
    async checkStockOrder(id) {
      const { data } = await checkStockOrder(id)
      if (data.code === this.$code) {
        this.$message.success(this.$t('system::tip::audit_success'))
        this.handlePageChange()
      }
    },
    toClose(row) {
      this.isShowClose = true
      this.selectStock = row
    },
    async closeStockOrder() {
      const { data } = await closeStockOrder({ id: this.selectStock.id, closeReason: this.closeReason })
      if (data.code === this.$code) {
        this.$message.success(this.$t('system::tip::close_success'))
        this.isShowClose = false
        this.handlePageChange()
      }
    },
    exportOrder() {}
  }
}
</script>

<style lang="scss" scoped>
.circle {
  display: inline-block;
  border-radius: 50%;
  width: 10px;
  height: 10px;
}
</style>
